// extracted by mini-css-extract-plugin
export var collapsedSummary = "_hg-0";